import React from 'react';
import { useFeatureFlags } from '@ApplicationWide/feature-flags';
import { filterRoutes } from '@ApplicationWide/routes/routeUtils';

const AbsenceManagementApprovalTimeOffPage = React.lazy(() =>
  import('../../pages/EmailTimeOff/AbsenceManagementApprovalTimeOffPage'),
);
const ApprovalTimeOffPage = React.lazy(() => import('../../pages/EmailTimeOff/ApprovalTimeOffPage'));
const OutdatedTimeOffPage = React.lazy(() => import('../../pages/EmailTimeOff/OutdatedTimeOffPage'));
const AddCommentPage = React.lazy(() => import('../../pages/EmailTimeOff/AddCommentPage'));
const CommentAddedPage = React.lazy(() => import('../../pages/EmailTimeOff/CommentAddedPage'));
const OrgChartSharedPage = React.lazy(() => import('../../pages/Company/OrgChartShared'));
const UserRequestedInformationPage = React.lazy(() => import('../../pages/UserRequestedInformationPage'));
const LinkExpiredPage = React.lazy(() => import('../ErrorPages/ErrorBoundaryPages/LinkExpiredPage'));

const publicRoutes = [
  {
    to: '/absence-management-approval',
    route: ['/absence-management-approval'],
    component: AbsenceManagementApprovalTimeOffPage,
  },
  {
    to: '/review_pto',
    route: ['/review_pto', '/review_pto/:hash'],
    component: ApprovalTimeOffPage,
  },
  {
    to: '/outdated-time-off',
    route: '/outdated-time-off',
    component: OutdatedTimeOffPage,
  },
  {
    to: '/time-off-comment',
    route: ['/time-off-comment', '/time-off-comment/:hash'],
    component: AddCommentPage,
  },
  { to: '/comment-added', route: '/comment-added', component: CommentAddedPage },
  {
    route: ['/orgchart/:id'],
    component: OrgChartSharedPage,
  },
  {
    route: ['/requested_information/:requested_info_id/:token'],
    component: UserRequestedInformationPage,
  },
  {
    route: ['/invitation-expired'],
    component: LinkExpiredPage,
  },
];

export const useAvailablePublicRoutes = () => {
  const featureFlags = useFeatureFlags();
  return filterRoutes(publicRoutes, featureFlags);
};
